export const PAYMENT_PROOF_MAX_BYTES = 8 * 1024 * 1024;

export const PAYMENT_PROOF_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "application/pdf",
] as const;

export const PAYMENT_PROOF_ACCEPT = ".jpg,.jpeg,.png,.webp,.pdf";

export function isPaymentProofMimeType(value: string | undefined): boolean {
  return PAYMENT_PROOF_MIME_TYPES.some((type) => type === value);
}
